


    angular.module('aprima-core-ui')
    .directive('apPharmacyTileDragDrop',[
        'PatientRepository',
        '$uibModal',
        function (PatientRepository,$modal){
            'use strict';
            return{
                scope:{
                    patientId: '<',
                    pharmacyDropDownSelection: '<',
                    pharmacyList: '&',
                    pharmacySelected:'&'
                        },
            templateUrl:'/core-ui/views/directives/partials/apPharmacyTileDragDrop.html',
            link:function($scope){

                        
                $scope.selectedPharmaryIndex=-1;
                $scope.selectedPharmaryIndex=$scope.pharmacyDropDownSelection;
                $scope.loadingPharmacy=false;
                $scope.pharmacyListData = [];
                $scope.deletePharmacy = deletePharmacy;  
                $scope.selectPharmacy = selectPharmacy;
                $scope.onDeletePatientPharmacy = onDeletePatientPharmacy;
                $scope.isSelected = isSelected;
                $scope.setStart= setStart;
                $scope.setDrop= setDrop;

                var startMoveIndex=-1;

                loadPatientPharmacies();

                $scope.$watch('pharmacyDropDownSelection',function(){
                    
                    checkforOut();

                });

                function checkforOut(){  

                    $scope.selectedPharmaryIndex = -1;
                    angular.forEach($scope.pharmacyListData, function(ph){
                     
                         if(ph.PatientPharmacyUid  === $scope.pharmacyDropDownSelection)
                         {
                             $scope.selectedPharmaryIndex  = $scope.pharmacyDropDownSelection;
                         }
                     });

                }
                
                function setStart(startIndex){

                    startMoveIndex = startIndex;                

                }
               
                function setDrop(dropIndex){

                    var newList = reorderArray($scope.pharmacyListData,startMoveIndex,dropIndex);
                    $scope.pharmacyListData = [];                 
                    $scope.pharmacyListData = newList;
                    $scope.$apply();                 
                    orderPharmacy($scope.pharmacyListData,$scope.patientId);
            
                }


                function selectPharmacy(guid) {
                    $scope.selectedPharmaryIndex = guid;
                    var obj = $scope.pharmacyListData.find( function (p) {return p.PatientPharmacyUid === guid;} );                    
                    $scope.pharmacySelected({pharmacy:obj});
                   
                }

                function reorderArray(array, from, to){
                    var element =  array[from];
                    array.splice(from, 1);
                    array.splice(to, 0, element);
                    return array;
                }

               function isSelected(i){
                    if($scope.selectedPharmaryIndex === i)
                    return true;
                    else
                    return false;
                }

               function deletePharmacy(pharmacyId) {                    
                    openModal().then(function (selectedItem) {                    
                    if(selectedItem)
                    {                        
                        $scope.onDeletePatientPharmacy(pharmacyId);
                    }
                });
                }

                
        function onDeletePatientPharmacy(guid){
            
            PatientRepository.deletePatientPharmacy(guid).then(function(){

                loadPatientPharmacies();
            });
            

        }

                 function openModal () {
            
                    var modalInstance = $modal.open({
                    templateUrl: '/core-ui/modal-views/deletePatientPharmacyConfirmModal.html',
                    controller: 'deletePatientPharmacyModalCtrl',
                    controllerAs: 'vm' ,
                    size:'sm'    
                    });
                    return modalInstance.result;

                    }

                function loadPatientPharmacies(){

                    $scope.loadingPharmacy = true;
                    PatientRepository.getPharmacies($scope.patientId).then(function (data) {
                    var x = data;
                    // get first 4 of patient pharmacy
                    $scope.pharmacyListData = x.splice(0,4);                   
                    checkforOut();                              
                    }).finally(function () {
                        $scope.loadingPharmacy = false;   
                    });

                    }

                function orderPharmacy(list, patientId){

                    $scope.loadingPharmacy = true;                    
                    var guidList = list.map(function(l){
                        return l.PatientPharmacyUid;
                    });
                    PatientRepository.setPharmacyOrder(guidList, patientId).then(function(){                    
                    }).finally(function (){
                        $scope.loadingPharmacy = false;   
                    });
                    }
        
            }
        };
    }
    ]);

        angular.module('aprima-core-ui').controller('deletePatientPharmacyModalCtrl', [
        '$scope',
        '$uibModalInstance',
        deletePatientPharmacyModalCtrl,
    ]);

        function deletePatientPharmacyModalCtrl($scope,$modalInstance) {
        'use strict';
        
            $scope.cancel = cancel;
            $scope.ok = ok;
       
        function cancel() {
            $modalInstance.dismiss(false);
        }

        function ok() {
            $modalInstance.close(true);
        }
    }